export enum CommentsCategory {
  Assets = 'Assets',
  AssetOperationTimes = 'AssetOperationTimes',
  POMQuestions = 'POMQuestions',
  MaterialOrders = 'MaterialOrders',
  HrocRegionalManagerKpis = 'HrocRegionalManagerKpis',
  ProcessWorkOrders = 'ProcessWorkOrders',
  MaterialInstallations = 'MaterialInstallations',
  StaticPartReplacements = 'StaticPartReplacements',
  OilAnalysisActions = 'OilAnalysisActions',
  MachineSentryActions = 'MachineSentryActions',
  DalogActions = 'DalogActions',
  POMActions = 'POMActions'
}

export enum CommentStatus {
  New = 'New',
  Edited = 'Edited'
}

export enum CommentsSortOrder {
  Ascending = 'Ascending',
  Descending = 'Descending'
}

export enum CommentsSortBy {
  CreatedOn = 'CreatedOn',
  UpdatedOn = 'UpdatedOn'
}

type BaseCommentDto = {
  commentId: string
  commentsCategory: CommentsCategory
  commentsCategoryInstanceId: string
  value: string
  createdOn: string
  createdBy: string
}

type NewCommentDto = BaseCommentDto & {
  status: CommentStatus.New
}

type EditedCommentDto = BaseCommentDto & {
  status: CommentStatus.Edited
  updatedOn: string
  updatedBy: string
}

export type CommentDto = NewCommentDto | EditedCommentDto

export type CommentPayloadDto = {
  value: string
}
